import React, { PureComponent } from 'react';
import { oneOfType, string, number, func, bool } from 'prop-types';
import ListItemControl from './ListItemControl';

class ListItem extends PureComponent {
  static propTypes = {
    id: oneOfType([string, number]).isRequired,
    name: string.isRequired,
    title: string.isRequired,
    value: oneOfType([string, number]).isRequired,
    onChange: func.isRequired,
    checked: bool.isRequired,
    onClick: func,
  };

  static defaultProps = {
    checked: false,
  };

  render() {
    const {
      id,
      name,
      title,
      value,
      onChange,
      onClick,
      checked,
      param,
      className,
      tag: Tag = 'li',
    } = this.props;

    return (
      <Tag>
        <div className="filter-list-item" onClick={onClick}>
          <ListItemControl
            id={id}
            name={name}
            title={title}
            value={value}
            onChange={onChange}
            checked={checked}
          />
          {param && <ins className="filter-list-item-param">{param}</ins>}
        </div>
      </Tag>
    );
  }
}

export default ListItem;
